import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Catalogs|Credentials';

export type CertCatalogLoc = 'CPCertCatalogFilterByGroupLabel';

export const cpCertCatalogLocs: LocDefs<CertCatalogLoc> = {
	CPCertCatalogFilterByGroupLabel: {
		defaultValue: 'Filter by Group',
		displayPath: `${dpRoot}|Filter by Group Label`,
		description: 'Label for filter by group.',
		displayType: 'Label',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<CertCatalogLoc>(cpCertCatalogLocs);
